// Nic Updated at 2026-06-25
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Outlet } from "react-router-dom";

const RedirectIfAuthenticated = ({ redirectTo = "/member_zone" }) => {
  const navigate = useNavigate();
  const savedRedirectUrl = localStorage.getItem("redirect_url");
  const memberInfoData = useSelector(
    (state) => state.memberInfo.memberInfoData
  );
  useEffect(() => {
    if (memberInfoData) {
      navigate(redirectTo, { replace: true });
    }
  }, [navigate, memberInfoData]);

  return <>{!memberInfoData && <Outlet />}</>;
};

export default RedirectIfAuthenticated;
